import React, { useState, useEffect, useRef } from 'react';
import { getCountryFlag } from '@/pages/home/_config/countries';
// import { getCountryFlag } from '@/utils/common';
import { useIntl, getLocale } from 'umi';
import { Popover, SearchBox } from 'tea-component';

import LoadState from './_loadState';
import './index.scss';
import { ISearchTableProps } from '@intelligence/pages/MarketProfile/components/MarketTableCard/type';

// export default function SearchTable(props: any) {
export default function SearchTable(props: ISearchTableProps) {
  const {
    countrieSelectList: data,
    allCountriesList = [],
    handleSearchData,
    regionsCountries,
    defaultValue = '',
  } = props;

  // 用于展示搜索的结果内容
  // 外层筛选器总列表
  // 筛选后的国家列表
  // 0---加载中,1---加载完毕有数据，2---加载完毕无数据
  const [popoverState, setPopoverState] = useState(0);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [popoverData, setPopoverData] = useState([]);
  const [allOptions, setAllOptions] = useState([]);
  const debounce = useRef({ interval: 0, delay: 500 }).current;
  const [searchKey, setSearchKey] = useState('');
  const [inMarketsButNotSelect, setInMarketsButNotSelect] = useState(false);
  const { formatMessage } = useIntl();
  const isEN = getLocale() === 'en-US';
  const allMarkets = regionsCountries?.map((area: any) => area.country_set).flat() || [];
  // const toTranslateCountry = (code: string) => allMarkets.find((country: any) => country.country_code === code)?.[isEN ? 'country_name_en' : 'country_name_ch'];
  // 只获取中文名;feat 英文状态下切中文搜索不到国家
  const toTranslateCountry = (code: string) =>
    allMarkets.find((country: any) => country.country_code === code)?.country_name_ch;

  useEffect(() => {
    if (defaultValue === 'resetSearch' && searchKey?.length) {
      setSearchKey('');
    }
  }, [defaultValue]);
  useEffect(() => {
    // 添加中文数据
    const allCountriesList_cn = allCountriesList?.map((country: any) => {
      const cnName = toTranslateCountry(country.enName) || country.name;
      return {
        ...country,
        cnName,
      };
    });
    const allSelectData_cn = data?.map((country: any) => {
      const cnName = toTranslateCountry(country.enName) || country.name;
      return {
        ...country,
        cnName,
      };
    });
    setAllOptions(allCountriesList_cn || []);
    setPopoverData(allSelectData_cn || []);
  }, [regionsCountries, allCountriesList]);

  const debounceChange = (value: any) => {
    setPopoverState(0);
    const trimValue = value.trim();
    if (trimValue != '') {
      clearTimeout(debounce.interval);
      // @ts-ignore
      debounce.interval = setTimeout(() => {
        setPopoverVisible(false);
        filterData(trimValue);
      }, debounce.delay);
    } else {
      handleSearchData('');
      setPopoverVisible(false);
    }
  };

  const filterData = (value: any) => {
    setPopoverVisible(true);
    const _searchSelectList = [] as any;
    // let _searchAllList = [];
    allOptions?.map((item: any) => {
      if (
        item.name.toLowerCase().indexOf(value.toLowerCase()) != -1 ||
        item.enName.toLowerCase().indexOf(value.toLowerCase()) != -1 ||
        item.cnName.indexOf(value) != -1
      ) {
        _searchSelectList.push(item);
      }
    });
    if (_searchSelectList.length != 0) {
      setPopoverState(1);
    } else {
      handleSearchData(value);
      setPopoverState(2);
    }
    setInMarketsButNotSelect(!_searchSelectList.length && allOptions.length);
    setPopoverData(_searchSelectList);
    setPopoverVisible(true);
  };

  const clearInput = (value: any) => {
    setSearchKey(value);
    setPopoverData([]);
    setPopoverVisible(false);
    handleSearchData('');
  };

  return (
    <>
      <Popover
        placement="bottom-end"
        visible={popoverVisible}
        placementOffset="2"
        destroyOnClose
        overlayClassName={
          popoverState == 1 ? 'searchTablePopover' : 'searchTablePopover searchTablePopover2'
        }
        overlay={
          popoverState == 0 ? (
            <></>
          ) : popoverState == 1 ? (
            popoverData.map((item, index) => (
              <div
                key={index}
                className="searchTablePopoverItem"
                onClick={() => {
                  setSearchKey(item[isEN ? 'name' : 'cnName']);
                  setPopoverVisible(false);
                  handleSearchData(item.name);
                }}
              >
                {item?.enName ? (
                  <img
                    src={getCountryFlag(item?.enName?.toLocaleUpperCase())}
                    style={
                      item.name.toLowerCase().indexOf('global') != -1
                        ? {}
                        : {
                            border: '1px solid #DDDDDD',
                            boxSizing: 'border-box',
                          }
                    }
                    onError={(e: any) => {
                      e.target.onerror = null;
                    }}
                  />
                ) : (
                  <></>
                )}
                <div className="searchTablePopoverItemName">{isEN ? item.name : item.cnName}</div>
              </div>
            ))
          ) : (
            <LoadState
              height={inMarketsButNotSelect ? 'auto' : '30px'}
              title={
                inMarketsButNotSelect ? (
                  <div className="searchNotFoundText">
                    {' '}
                    <div>sorry, no result found.</div>
                    <div>Please check that the keywords are correct or hidden.</div>
                  </div>
                ) : (
                  'No results found.'
                )
              }
              justify="left"
            />
          )
        }
      >
        <SearchBox
          className={'popoverSearchClass'}
          value={searchKey}
          defaultValue={searchKey}
          placeholder={formatMessage({ id: 'dbi_global_view_search_any_market' })}
          onClear={() => {
            // console.log('onClear');
            clearInput('');
          }}
          onSearch={(word) => {
            // console.log('onSearch',word);
            const trimValue = word?.trim();
            handleSearchData(trimValue);
          }}
          onChange={(word) => {
            // console.log('onChange',word);
            setSearchKey(word);
            debounceChange(word);
          }}
          onBlur={() => {
            setTimeout(() => {
              // console.log('onBlur');
              setPopoverVisible(false);
            }, 200);
          }}
        />
      </Popover>
    </>
  );
}
